import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home } from "lucide-react";
import { useUiPack } from "@/hooks/useUiPack";
import Waiter from "@/pages/Waiter";
import { useLocale } from "@/contexts/LocaleProvider";
import "@/styles/simple-ui.css";

/**
 * Waiter is already touch-first. Simple pack wraps it with Home access
 * and keeps the same order/KOT APIs (aligned with Simple POS).
 */
export default function UiPackWaiter() {
  const { isSimple } = useUiPack();
  const { t } = useTranslation();
  const { isRtl } = useLocale();

  if (!isSimple) return <Waiter />;

  return (
    <div className="simple-ui flex h-full min-h-0 flex-col" dir={isRtl ? "rtl" : "ltr"} data-testid="simple-waiter-shell">
      <div className="flex shrink-0 items-center gap-2 border-b border-violet-200 bg-violet-600 px-3 py-2 text-white print:hidden">
        <Link
          to="/"
          className="inline-flex h-10 items-center gap-1.5 rounded-xl bg-white/15 px-3 text-sm font-bold hover:bg-white/25"
        >
          <Home className="h-4 w-4" />
          {t("common.home")}
        </Link>
        <span className="text-sm font-semibold opacity-90">{t("nav.waiterOrders")}</span>
      </div>
      <div className="min-h-0 flex-1 overflow-hidden">
        <Waiter />
      </div>
    </div>
  );
}
